import {
	DEFAULT_AUTHORITY,
	DEFAULT_ISSUER,
	DEFAULT_META_DATA_URL,
} from '@shared/constants/auth';
import { CUSTOM_AUTH_DOMAIN_CACHE_KEY } from '@shared/constants/white-label';

import { deserializeLocalStorageValue } from '../localStorage';

export const getIssuer = (domain?: string) => {
	const customAuthDomain =
		domain ||
		deserializeLocalStorageValue<string>(CUSTOM_AUTH_DOMAIN_CACHE_KEY);

	if (customAuthDomain) {
		return DEFAULT_ISSUER.replace(
			import.meta.env.VITE_AUTH_BASE_URL,
			customAuthDomain
		);
	}

	return DEFAULT_ISSUER;
};

export const getAuthority = (domain?: string) => {
	const customAuthDomain =
		domain ||
		deserializeLocalStorageValue<string>(CUSTOM_AUTH_DOMAIN_CACHE_KEY);

	if (customAuthDomain) {
		return DEFAULT_AUTHORITY.replace(
			import.meta.env.VITE_AUTH_BASE_URL,
			customAuthDomain
		);
	}

	return DEFAULT_AUTHORITY;
};

export const getMetadataUrl = (domain?: string) => {
	const customAuthDomain =
		domain ||
		deserializeLocalStorageValue<string>(CUSTOM_AUTH_DOMAIN_CACHE_KEY);

	if (customAuthDomain) {
		return DEFAULT_META_DATA_URL.replace(
			import.meta.env.VITE_AUTH_BASE_URL,
			customAuthDomain
		);
	}

	return DEFAULT_META_DATA_URL;
};

export const getSessionOidcAuthKey = () => {
	const authority = getAuthority();

	return `oidc.user:${authority}:${import.meta.env.VITE_AUTH_CLIENT_ID}`;
};

export const getGlobalRefreshTokenKey = () => {
	const authority = getAuthority();

	return `global.refresh-token:${authority}:${import.meta.env.VITE_AUTH_CLIENT_ID}`;
};

export const getOnBoardingAccessTokenKey = () => {
	const authority = getAuthority();

	return `onboarding.access-token:${authority}:${import.meta.env.VITE_AUTH_CLIENT_ID}`;
};
